"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function chatInit(user) {
    var _a, _b;
    if (!user)
        return function () { return null; };
    window.LHCChatOptions = {};
    window.LHCChatOptions.attr = [];
    window.LHCChatOptions.attr.push({ name: 'ID', value: user.id, type: 'hidden' });
    window.LHCChatOptions.attr.push({ name: 'Email', value: user.email, type: 'hidden' });
    window.LHCChatOptions.attr.push({ name: 'Nome', value: (_a = user.name) !== null && _a !== void 0 ? _a : user.email, type: 'hidden' });
    window.LHCChatOptions.attr_prefill = [];
    window.LHCChatOptions.attr_prefill.push({ name: 'email', value: user.email });
    window.LHCChatOptions.attr_prefill.push({ name: 'username', value: (_b = user.name) !== null && _b !== void 0 ? _b : user.email });
    loadScript();
    return function () {
        var _a;
        window.LHCChatOptions = {};
        (_a = window.$_LHC) === null || _a === void 0 ? void 0 : _a.eventListener.emitEvent('terminated');
    };
}
exports.default = chatInit;
function loadScript() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            if (window.__houston_chat_loader__) {
                return [2 /*return*/, window.__houston_chat_loader__.then(function () {
                        window.$_LHC.eventListener.emitEvent('terminated');
                        window.$_LHC.init();
                    })];
            }
            window.__houston_chat_loader__ = new Promise(function (resolve) {
                window.LHCChatOptions.opt = {
                    widget_height: 400,
                    widget_width: 340,
                    popup_height: 520,
                    popup_width: 500
                };
                var refferer = document.referrer
                    ? encodeURIComponent(document.referrer.substring(document.referrer.indexOf('://') + 1))
                    : '';
                var location = document.location
                    ? encodeURIComponent(window.location.href.substring(window.location.protocol.length))
                    : '';
                var scriptImport = document.createElement('script');
                scriptImport.type = 'text/javascript';
                scriptImport.async = true;
                scriptImport.src = "https://chat.eduzz.com/index.php/por/chat/getstatus/(click)/internal/(position)/bottom_right/(ma)/br/(top)/350/(units)/pixels/(leaveamessage)/true/(department)/23/(theme)/12?r=".concat(refferer, "&l=").concat(location, ";");
                document.head.appendChild(scriptImport);
                document.body.classList.add('houston-topbar-chat-applied');
                scriptImport.onload = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var count;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                count = 0;
                                _a.label = 1;
                            case 1:
                                if (!(!window.$_LHC && count < 20)) return [3 /*break*/, 3];
                                count++;
                                return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, 1000); })];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 1];
                            case 3:
                                resolve();
                                return [2 /*return*/];
                        }
                    });
                }); };
            });
            return [2 /*return*/, window.__houston_chat_loader__];
        });
    });
}
